/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";

export function SortableItem(props: any) {
  const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id: props.id, disabled: false});

  const style = {
    transform: CSS.Transform?.toString(transform),
    transition,
  };

  return (
    <div
      style={{touchAction: props.disabled ? 'initial' : 'none', ...style, ...props?.style}}
      ref={setNodeRef}
      {...(props.disabled ? {} : attributes)}
      {...(props.disabled ? {} : listeners)}
    >
      {/*<Image src={props.value} />*/}
      {props?.children}
      {/*<Card>*/}
      {/*  test*/}
      {/*</Card>*/}
    </div>
  );
}
